import Vue from 'vue'
import Vuex from 'vuex'

// Global vuex
import AppModule from './app'

import { signupOne } from './gate/signup.one'
import { registrationRequestOne } from './gate/registration_request.one'

Vue.use(Vuex)

/**
 * Main Vuex Store
 */
const store = new Vuex.Store({
  modules: {
    app: AppModule,
    signupOne,
    registrationRequestOne   
  }
})

export default store
